import {addDoc, collection, Timestamp} from 'firebase/firestore';
import {firestore, getCollectionPath} from '../config/Firebase';
import Storage from './Storage';
import Debug from './Debug';
import appData from "../../package.json";

export default class Activity {
    static log(entityType, entityId, action, metadata) {
        const appName = appData.name || 'unknown';
        const fingerprint = Storage.getFingerprint();
        const session = Storage.getSession();
        const store = Storage.getStore();
        const hasRequiredData = entityType && entityId && action;
        if (hasRequiredData) {
            let data = {
                app_name: appName,
                fingerprint: fingerprint || null,
                session: session || null,
                store: store,
                entity_type: entityType,
                entity_id: entityId || null,
                action: action,
                timestamp: Timestamp.now()
            };
            metadata = metadata ? metadata : {};
            metadata.userAgent = navigator.userAgent || null;
            try {
                metadata.userAgentData = navigator?.userAgentData?.toJSON() || 'unavailable';
            } catch (error) {
                Debug.printToLog('error', error.message);
                metadata.userAgentData = 'unavailable';
            }
            data.metadata = metadata;
            const _path = getCollectionPath('activity');
            const _collection = collection(firestore, _path);
            try {
                return addDoc(_collection, data)
                    .catch((error) => {
                        Debug.printToLog('error', error);
                    });
            } catch (error) {
                Debug.printToLog('error', error);
                return Promise.resolve();
            }
        } else {
            Debug.printToLog('error', 'Activity.log() is missing required data.');
            Debug.printToLog('error', {store, entityType, entityId, action, metadata});
            return Promise.resolve();
        }
    };
}